export const optionsTypes = {
  "dynamic-single-select": "dynamic-single-select",
  "static-single-select-key-value": "static-single-select-key-value",
  "static-single-select-array": "static-single-select-array"
};

export const filterPage = {
  adminConsoleDisplay: "adminConsoleDisplay",
  consultantInncodePlansDisplay: "consultantInncodePlansDisplay",
  consultantListDisplay: "consultantListDisplay",
  consultantListPlanProgressDisplay: "consultantListPlanProgressDisplay",
  consultantListPropertyPlanProgressDisplay: "consultantListPropertyPlanProgressDisplay",
  consultantListUserPlanProgressDisplay: "consultantListUserPlanProgressDisplay",
  dashboardDisplay: "dashboardDisplay",
  hotelDisplay: "hotelDisplay",
  inncodePlansDisplay: "inncodePlansDisplay",
  individualPropertyBrandDeadlineDisplay: "individualPropertyBrandDeadlineDisplay",
  individualPropertyInitiativesDisplay: "individualPropertyInitiativesDisplay",
  individualPropertyMembersDisplay: "individualPropertyMembersDisplay",
  individualPropertyPlansDisplay: "individualPropertyPlansDisplay",
  individualUsersDisplay: "individualUsersDisplay",
  libraryAllPlansDisplay: "libraryAllPlansDisplay",
  libraryAllPlansSearchDisplay: "libraryAllPlansSearchDisplay",
  libraryAllPlansSearchIndividualActionsDisplay: "libraryAllPlansSearchIndividualActionsDisplay",
  libraryBookmarkedPlansDisplay: "libraryBookmarkedPlansDisplay",
  libraryFunctionalAreasDisplay: "libraryFunctionalAreasDisplay",
  libraryFunctionalAreasIndividualActionsDisplay: "libraryFunctionalAreasIndividualActionsDisplay",
  listDisplay: "listDisplay",
  manageSuggestionsDisplay: "manageSuggestionsDisplay",
  planProgressFromLibraryDisplay: "planProgressFromLibraryDisplay",
  planProgressFromMyListDisplay: "planProgressFromMyListDisplay",
  planProgressFromPlansDisplay: "planProgressFromPlansDisplay",
  planProgressUnimplementedFromPlansDisplay: "planProgressUnimplementedFromPlansDisplay",

  plansPageAssignedPlansDisplay: "plansPageAssignedPlansDisplay",
  plansPageTemplatePlansDisplay: "plansPageTemplatePlansDisplay",
  plansPageBrandDeadlineDisplay: "plansPageBrandDeadlineDisplay",
  plansPageInitiativesDisplay: "plansPageInitiativesDisplay",
  libraryPlanDetailsDisplay: "libraryPlanDetailsDisplay"
};

export const progressTypesFilterValue: { [key: string]: string } = {
  plan: "consultantListPlanProgressDisplay",
  property: "consultantListPropertyPlanProgressDisplay",
  users: "consultantListUserPlanProgressDisplay"
};

export const filtersToClearOnBackClick: any = {
  functionalArea: [filterPage.libraryFunctionalAreasDisplay, filterPage.libraryFunctionalAreasIndividualActionsDisplay],
  plandetails: [
    filterPage.planProgressFromLibraryDisplay,
    filterPage.planProgressFromMyListDisplay,
    filterPage.libraryPlanDetailsDisplay
  ],
  property: [
    filterPage.individualPropertyPlansDisplay,
    filterPage.individualPropertyBrandDeadlineDisplay,
    filterPage.individualPropertyInitiativesDisplay,
    filterPage.individualPropertyMembersDisplay
  ],
  userview: [filterPage.individualUsersDisplay],
  planProgress: [filterPage.planProgressFromPlansDisplay]
};

export const flagMap = {
  selectAllProperties: ["inncode", "filteredInnCodes", "innCode"],
  selectAllManagementCompanies: ["managementCompany"],
  selectAllOwnerGroup: ["ownerGroup"],
  selectAllPlans: ["planCmsId", "ids", "cmsId"]
};

export const filterPayloadForSelectAllFeature = (payload: any) => {
  return payload?.filter((item: any) => item?.options?.length);
};

export const filterSliceInitialState: any = Object.keys(filterPage).reduce((acc: any, key: any) => {
  acc[key] = {
    defaultFilter: [],
    modifiedFilter: [],
    dynamicSelectAll: {
      selectAllProperties: false,
      selectAllManagementCompanies: false,
      selectAllOwnerGroup: false,
      selectAllPlans: false
    },
    isFilterApplied: false
  };
  return acc;
}, {});

export const getKeyValue = (list: any, key: string, value: string) => {
  const keyValueList = list.map((item: any) => {
    return { key: item[key], value: item[value] };
  });
  return keyValueList;
};
